function isAllInputDataNumber(input) {
    return input.every(val => {
        return Number.isInteger(val);
    });
}

function generateSubText(daysLeftInHours, loansLeft, daysLeft) {
    if (!isAllInputDataNumber([daysLeftInHours, loansLeft, daysLeft])) {
        return null;
    }

    if (loansLeft < 1) {
        return { key: 'ended', timeLeft: null };
    }

    if (daysLeftInHours < 1) {
        return { key: 'expired', timeLeft: null };
    }

    if (daysLeftInHours > 48) {
        return { key: 'daysLeft_other', timeLeft: daysLeft };
    }

    if (daysLeftInHours <= 24) {
        return { key: 'daysLeftInHours', timeLeft: daysLeftInHours };
    }

    const hoursLeftUnderOneDay = daysLeftInHours > 24 ? daysLeftInHours - 24 : daysLeftInHours;
    return { key: 'hoursLeftUnderOneDay', timeLeft: hoursLeftUnderOneDay };
}

export { generateSubText };
